var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipPre(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 122,
    viewBox: "0 0 165 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5595 48.9035C34.8629 45.6898 57.1007 51.0717 82.474 61.6337C107.847 72.1957 127.348 84.1878 128.096 89.4974C127.697 90.112 127.248 90.6929 126.755 91.2345C117.546 101.792 93.6368 102.755 69.5273 92.719C45.4178 82.6831 29.2662 65.0441 30.2562 51.1008C30.2998 50.3616 30.4012 49.6269 30.5595 48.9035Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4007 85.8496C110.474 101.698 145.472 104.616 150.571 92.367C155.67 80.1178 128.939 57.34 90.8654 41.4914C52.7919 25.6428 17.7938 22.7249 12.6949 34.974C7.59599 47.2232 34.3272 70.001 72.4007 85.8496Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.681 82.7744C111.754 98.623 146.753 101.541 151.852 89.2918C156.95 77.0426 130.219 54.2648 92.1457 38.4162C54.0722 22.5676 19.074 19.6497 13.9752 31.8989C8.87626 44.148 35.6075 66.9258 73.681 82.7744Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.14 64.0284C109.028 67.7732 96.4507 66.3987 82.8595 60.7412C69.2684 55.0837 59.455 47.1379 59.8989 42.2895C60.2412 41.6528 60.6086 41.0406 60.9948 40.4502C64.6061 34.8526 70.072 30.7023 76.4376 28.7246C82.8031 26.7469 89.6636 27.0675 95.8204 29.6303C101.977 32.1931 107.039 36.8353 110.121 42.7457C113.203 48.6561 114.109 55.459 112.682 61.9657C112.526 62.6448 112.35 63.3369 112.14 64.0284Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.636 63.2243C112.513 63.5165 112.346 63.7879 112.14 64.0285C109.028 67.7733 96.4506 66.3988 82.8594 60.7413C69.2683 55.0838 59.4548 47.138 59.8988 42.2896C59.9242 41.9737 59.9987 41.6637 60.1197 41.3707C60.3094 40.9182 60.6019 40.516 60.9741 40.1961L60.9947 40.4504C61.5663 45.3073 71.055 52.7669 83.9573 58.1377C96.8596 63.5085 108.833 64.9826 112.682 61.9658L112.877 61.8013C112.907 62.2879 112.825 62.775 112.636 63.2243Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7524 38.0048C13.7524 38.0048 36.7732 34.3132 59.6072 42.9898",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.813 93.8094C147.813 93.8094 134.188 74.8632 111.983 64.792",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.02 64.2402C97.2304 72.5967 98.934 81.9893 97.9256 91.2866",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8994 55.4487C63.0036 58.3503 55.1388 63.7596 49.2513 71.0255",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5849 75.7979C79.3274 76.9395 82.4749 75.6443 83.6152 72.905C84.7555 70.1657 83.4566 67.0196 80.7142 65.8781C77.9717 64.7365 74.8242 66.0317 73.6839 68.771C72.5436 71.5103 73.8424 74.6563 76.5849 75.7979Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.031 73.8871C140.905 72.6907 139.5 70.1776 136.893 68.2738C134.286 66.3701 131.463 65.7967 130.589 66.993C129.714 68.1893 131.119 70.7025 133.726 72.6062C136.334 74.5099 139.156 75.0834 140.031 73.8871Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9663 32.7447C41.1544 33.2534 43.9275 32.4793 44.1602 31.0158C44.3929 29.5523 41.9971 27.9536 38.8091 27.4449C35.621 26.9363 32.848 27.7103 32.6153 29.1738C32.3825 30.6373 34.7783 32.236 37.9663 32.7447Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.858 86.0576C121.839 84.8534 121.901 81.3453 119.998 78.2221C118.094 75.0989 114.945 73.5432 112.965 74.7474C110.984 75.9516 110.922 79.4596 112.825 82.5828C114.729 85.706 117.877 87.2617 119.858 86.0576Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.686 54.9854C50.2378 54.1446 52.6831 51.6388 52.1478 49.3885C51.6125 47.1382 48.2993 45.9956 44.7475 46.8365C41.1957 47.6773 38.7504 50.1831 39.2857 52.4334C39.821 54.6837 43.1342 55.8263 46.686 54.9854Z",
    fill: "black",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M113.255 57.8375C113.255 57.8375 118.938 53.4856 125.928 56.0933",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4062 37.0875C63.4062 37.0875 62.4892 29.9879 55.7139 26.8657",
    stroke: "#DCE0DF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipPre);
export default __webpack_public_path__ + "static/media/shipPre.cbe8b4745464fe1a3b31af888215bf3f.svg";
export { ForwardRef as ReactComponent };